import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);
const blacklist = ["product-settings", "user"];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
    },
    {
      path: "/logout",
      name: "logout",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Logout.vue"),
    },
    {
      path: "/opret-bruger",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Register.vue"),
    },
    {
      path: "/glemt",
      name: "forgot",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Forgot.vue"),
    },
    {
      path: "/reset/:uid/:resetToken/:email",
      name: "reset",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Reset.vue"),
    },
    {
      path: "/bruger",
      name: "user",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/User.vue"),
    },
    {
      path: "/abonnement",
      name: "subscription",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Subscription.vue"),
    },
    {
      path: "/produkt-indstillinger",
      name: "product-settings",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/ProductSettings.vue"),
    },
    {
      path: "/produkter",
      name: "products",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Products.vue"),
    },
    {
      path: "/invitation/:coupon?",
      name: "invitation",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Invitation.vue"),
    },
    {
      path: "/landing",
      name: "landing",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Landing.vue"),
    },
    {
      path: "/article",
      name: "article",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Article.vue"),
    },
    {
      path: "/bliv-medlem",
      name: "buy",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Buy.vue"),
    },
    {
      path: "/tak",
      name: "thanks",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Thanks.vue"),
    },
    {
      path: "/betaling",
      name: "payment",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Payment.vue"),
    },
    {
      path: "/betalings-fejl",
      name: "error",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/PaymentError.vue"),
    },
    {
      path: "/betalingskort",
      name: "creditcard",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/CreditCard.vue"),
    },
    {
      path: "/rabat/:coupon?",
      name: "coupon",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Coupon.vue"),
    },
    {
      path: "/kvitteringer",
      name: "reciepts",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Reciepts.vue"),
    },
    {
      path: "/om-os",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    ,
    {
      path: "/velkommen",
      name: "welcome",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "welcome" */ "./views/Welcome.vue"),
    },
    {
      path: "/check",
      name: "check",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "welcome" */ "./views/Check.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  router.app.$userService
    .get()
    .then((data) => {
      if (data) {
        to.meta.user = data;
        next();
      } else {
        to.meta.user = null;
        if (blacklist.includes(to.name)) {
          next({ name: "login" });
        }
        next();
      }

      //return data;
    })
    .catch((error) => {
      to.meta.user = null;
      if (blacklist.includes(to.name)) {
        next({ name: "login" });
      }
      next();
    });
});

export default router;
